import React, {useEffect, useState, useRef} from 'react';
import {useRecoilValue} from 'recoil';

import {AddressList} from '../../../store';
import FilterModalHeader from '../FilterModal/FilterModalHeader';
import AddressSelector from './AddressSelector';

interface Props {
  selectedAddress: string;
  select: (sc: string, ids: number[]) => void;
  isOpen: boolean;
  togglePopup: (is: boolean) => void;
}

export default function AddressModal({
  selectedAddress,
  select,
  isOpen,
  togglePopup,
}: Props) {
  const parentAddress = useRecoilValue(AddressList);
  const [childAddress, setChildAddress] = useState<Address[]>([]);
  const [selectedParent, setSelectedParent] = useState('서울시');
  const [selectorAddress, setSelectorAddress] = useState<Address[]>([]);
  const [selectedChild, setSelectedChild] = useState('');
  const [openSelector, setOpenSelector] = useState(false);
  const [isOnline, setIsOnline] = useState(false);
  const [selectorType, setSelectorType] = useState<'parent' | 'child'>(
    'parent',
  );
  const complete = () => {
    if (isOnline) {
      select(`온라인 스토어`, [9999, 9999]);
    } else {
      select(`${selectedParent} ${selectedChild}`, [
        parentAddress.find(o => o.address === selectedParent)?.id as number,
        childAddress.find(o => o.address === selectedChild)?.id as number,
      ]);
    }
    togglePopup(false);
  };

  const init = async () => {
    const _childAddress: Address[] = parentAddress.filter(
      d => d.address === selectedParent,
    )[0].child as Address[];
    setChildAddress(_childAddress);
  };

  const toggleOpenSelector = (type: 'parent' | 'child') => {
    setSelectorType(type);
    setOpenSelector(true);
    setSelectorAddress(type === 'parent' ? parentAddress : childAddress);
  };

  const toggleSelectorListItem = (address: Address) => {
    if (selectorType === 'parent') {
      setSelectedParent(address.address);
      setSelectedChild('');
    } else {
      setSelectedChild(address.address);
    }
    setOpenSelector(false);
  };

  const toggleOnline = () => {
    setIsOnline(!isOnline);
  };

  const initSelectedAddress = () => {
    if (
      selectedAddress &&
      selectedAddress.length > 0 &&
      selectedAddress !== '온라인 스토어'
    ) {
      const addressArr = selectedAddress.split(' ');
      setSelectedParent(addressArr[0]);
      setSelectedChild(addressArr[1]);
    } else {
      setSelectedParent('서울시');
      setSelectedChild('');
    }
  };

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (parentAddress.length > 0) {
      const _childAddress: Address[] = parentAddress.filter(
        d => d.address === selectedParent,
      )[0].child as Address[];
      setChildAddress(_childAddress);
    } else {
      init();
    }
  }, [selectedParent]);

  useEffect(() => {
    if (isOpen) {
      initSelectedAddress();
    }
  }, [isOpen]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleClickOutside = (event: any) => {
    if (
      wrapperRef &&
      !wrapperRef?.current?.contains(event.target) &&
      !openSelector
    ) {
      togglePopup(false);
    }
  };

  return (
    <div className="modal-wrapper" style={{display: isOpen ? 'flex' : 'none'}}>
      <div
        className={`modal-contents category ${isOpen ? 'active' : 'none'}`}
        ref={wrapperRef}>
        <FilterModalHeader
          txt={'지역 검색'}
          close={() => togglePopup(false)}
          fnTxt="초기화"
        />
        <div className="address-modal-body">
          <div
            className="address-selector"
            onClick={() => (isOnline ? '' : toggleOpenSelector('parent'))}>
            <input
              type="text"
              className={selectedChild.length > 0 ? 'has-child' : ''}
              placeholder="지역선택"
              value={selectedParent}
              readOnly
              disabled={isOnline}
            />
            <span className="icon arrow-down-black-icon">&nbsp;</span>
          </div>
          <div
            className="address-selector"
            style={{marginLeft: '15px'}}
            onClick={() => (isOnline ? '' : toggleOpenSelector('child'))}>
            <input
              type="text"
              className={selectedChild.length > 0 ? 'has-child' : ''}
              placeholder="시/군/구"
              value={selectedChild}
              readOnly
              disabled={isOnline}
            />
            <span className="icon arrow-down-black-icon">&nbsp;</span>
          </div>
        </div>
        <div className="is-online">
          <input type="checkbox" id="online" onChange={() => toggleOnline()} />
          <label htmlFor="online">온라인 스토어</label>
        </div>
        <div className="filter-modal-footer">
          <button
            className="modal btn black-filled address-btn"
            onClick={() => complete()}
            disabled={selectedChild.length === 0 && !isOnline}
            style={{
              background: !(selectedChild.length === 0 && !isOnline)
                ? '#000'
                : '#E9E7EC',
            }}>
            선택 완료
          </button>
          <button
            className="modal btn empty"
            onClick={() => togglePopup(false)}>
            취소
          </button>
        </div>
      </div>
      <AddressSelector
        type={selectorType}
        selectedAddress={
          selectorType === 'parent' ? selectedParent : selectedChild
        }
        addressList={selectorAddress}
        toggle={(address: Address) => toggleSelectorListItem(address)}
        isOpen={openSelector}
        close={() => setOpenSelector(false)}
      />
    </div>
  );
}
